import { Component, ComponentFactoryResolver, Injector, Input, AfterViewInit, OnInit, ViewChild, ViewContainerRef, OnDestroy } from '@angular/core';
import { BaseFormComponentComponent } from 'src/app/shared/base-form-component/base-form-component.component';
import { StepperService } from '../../stepper.service';
import { Subscription } from 'rxjs';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


import { AirModel } from '../../models/air/air-model';
import { AirPackModel } from '../../models/air/air-pack-model';
import { AirSearchComponent } from './air-search/air-search.component';
import { AirPriceRequestComponent } from './price-request/price-request.component';
import { AirReservationInformationComponent } from './reservation-information/reservation-information.component';
import { AirConfirmationComponent } from './confirmation/confirmation.component';
import { SearchDetailDialog } from "../../components/search-detail-dialog/search-detail-dialog.component";
import { PStepsComponent } from 'src/app/framework/p-steps/p-steps.component';
import { Router } from '@angular/router';
import { DecimalPipe } from 'src/app/shared/decimal.pipe';
import { TranslateService } from '@ngx-translate/core';
import { AirSearchService } from 'src/app/services/air/air-search.service';
import { SseService } from 'src/app/services/sse-service';

@Component({
  selector: 'app-air',
  templateUrl: './air.component.html',
  styleUrls: ['./air.component.scss']
})

export class AirComponent extends BaseFormComponentComponent implements OnInit, AfterViewInit, OnDestroy {


  private unsubscriber : Subject<void> = new Subject<void>();
  cwValue = 166.666667;
  @Input("step") step: number = 1
  @Input("showOnlyComponent") showOnlyComponent: boolean = false;
  @ViewChild('container', { read: ViewContainerRef }) container: ViewContainerRef;
  @Input("modelType") modelType: string = "AIR";
  @Input("viewType") viewType: string = null;
  @ViewChild("stepper", { static: false }) stepper: PStepsComponent;
  dynamicComponentRef: any;

  model = new AirModel();
  showRigthPanel: boolean = true;
  panelDisplayOption: any =  {
    showInfo: true,
    showLocation: true,
    showCargo: true,
  }
  parentComponent: SearchDetailDialog;


  productLoading: boolean = false;
  searchInfoLoading: boolean = false;
  reservationInfoLoading: boolean = false;
  initialOffsetTop: number = 0;

  stepSubscription: Subscription;
  stepComponents = {
    1: AirSearchComponent,
    2: AirPriceRequestComponent,
    3: AirReservationInformationComponent,
    4: AirConfirmationComponent
  }

  constructor(protected injector: Injector, private decimalPipe: DecimalPipe, private airService: AirSearchService, private componentFactoryResolver: ComponentFactoryResolver,
      private translateService: TranslateService, private router: Router, private stepperService: StepperService, private sseService: SseService) {
    super(injector);
    //this.isLoading = true;
  }

  ngOnInit(): void {
    // Ui'de yeniden ekle butonu olmadığı için varsayılan boş bir packModel ekleniyor.
    if(!this.model.packs) this.model.packs = [];
    if(!this.model.packs || this.model?.packs?.length  == 0 )  this.model.packs.push(new AirPackModel());

    if(!this.showOnlyComponent) {
      this.stepperService.changeCurrentStep(this.step);
    }
    

    history.pushState(null, '');

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {


      if(this.stepperService.step != 1) {
  
        if(this.stepperService.step == 3) {
          this.container.clear();
          this.stepperService.changeCurrentStep(1);
        } else {
          this.container.clear();
          this.stepperService.changeCurrentStep(this.stepperService.step -1);
        }

      } else {
        setTimeout(() => { this.router.navigate(['home'], { replaceUrl: true })}, 200);
      }
    

    });


  }



  ngAfterViewInit(): void {

    setTimeout(() => this.initialOffsetTop = document.querySelector<HTMLElement>(".header-img")?.offsetHeight, 500)

      /* Stepper'dan step numarası değiştirildiğinde... ilgili adıma ait component renderlanıyor.  */
      this.stepSubscription = this.stepperService.currentStep.subscribe((step: number) => {
        if(!this.showOnlyComponent) this.renderStepComponent(this.stepComponents[step]);
      })
  }

  ngOnDestroy(): void {
    this.stepSubscription.unsubscribe();
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

    closeDialog(){
        if (this.parentComponent) this.parentComponent.closeDialog();
    }



  renderStepComponent(comp: any, airModel: AirModel = this.model, step = 1) {
      this.container.clear();
      
      if(step == 4 && this.showOnlyComponent) {
        this.panelDisplayOption.showInfo = false;
        this.panelDisplayOption.showLocation = false;
      }

      if( !this.showOnlyComponent && ((step == 3 && !this.model?.selectedProduct) || this.model.shipmentNo) && (step != 4) ) {
        this.showRigthPanel = false;
      }


      window.scroll({ top: 0,  left: 0, behavior: 'smooth' });

      switch ( step ) {
        case 1:
            this.searchInfoLoading = true;
            break;
        case 2:
            this.productLoading = true;
            break;
        case 3:
            this.reservationInfoLoading = true;
            break;
        case 4:
            this.reservationInfoLoading = true;
            break;
        default:
            this.isLoading = true;
            break;
     }


    // create the component factory
    const dynamicComponentFactory = this.componentFactoryResolver.resolveComponentFactory(comp);
    // add the component to the view
    const componentRef = this.container.createComponent(dynamicComponentFactory);
    this.dynamicComponentRef = componentRef
    componentRef.instance['model'] = airModel;
    if(this.viewType) componentRef.instance['viewType'] = this.viewType;

    window.scroll({ top: this.initialOffsetTop,  left: 0, behavior: 'smooth' });

    this.isLoading = false;
    this.productLoading = false;
    this.reservationInfoLoading  = false;
    this.searchInfoLoading = false;

  }

  calculateTotals(event:any = null) {
    if(this.model.td == 'T') {
      const calculatedCwg = (Number(String( event?.value || this.model.totalVolume).replace(',', '.')) * this.cwValue);
      this.model.cwg =  Number(Number(this.decimalPipe.transform(calculatedCwg > this.model.totalWeight ? calculatedCwg : this.model.totalWeight)).toFixed())
    }
    if(this.model.td == 'D') {

      //calculate total pieces
      this.model.calculatedPieces = 0;
      const pieces = this.model.packs.filter(f => f.pieces).map(f => f.pieces);
      if(pieces.length > 0)  this.model.calculatedPieces = pieces.reduce((a,b) => a + b);

      // calculate total weight
      this.model.totalWeight = 0;
      this.model.packs.forEach(p => {
        this.model.totalWeight = (this.model.totalWeight ?? 0) + Number(((p.pieces ?? 0) * (p.perKg ?? 0)).toFixed(3));
      })


      // calculate line volume & calculate line total weight
      this.model.packs.forEach(i => {
        i.lineVolume = Number(((((i.height ?? 0) * (i.lenght ?? 0) * (i.width ?? 0)) / 1000000) * (i.pieces ?? 0)));
        i.totalWeight = Number(((i.perKg ?? 0) * (i.pieces ?? 0)).toFixed(3));
      })


      // calculate total volume
      this.model.totalVolume = 0;
      const volumes = this.model.packs.filter(f => f.lineVolume).map(f => f.lineVolume);
      if(volumes.length > 0)  this.model.totalVolume = Number(volumes.reduce((a,b) => a + b).toFixed(3));


      // calculate cwg
      this.model.cwg = 0;
      const cwg =  ((Number(String(this.model.totalVolume).replace(',', '.')) || 0) * this.cwValue) > this.model.totalWeight ? ((this.model.totalVolume || 0) * this.cwValue) : this.model.totalWeight;
      this.model.cwg = Number(Number(this.decimalPipe.transform(cwg)).toFixed());
    }
  }

  async onBlurTotalVolume() {
    if (this.model.totalVolume == null || this.model.totalVolume === 0) return;

    let num = Number(this.model.totalVolume);

    if (isNaN(num)) return;

    if(num > 10) {
      const message = await this.translateService.get('heightM3Message').toPromise();
      this.messageService.add({severity: 'warn',  key: 'html-msg', summary: '', detail: message });
    }

    // Round
    num = Math.round(num * 100) / 100;

    // Modele yaz
    this.model.totalVolume = num;

    // Input’a formatlı 2 basamak yaz (ngModel zaten güncelleyecek)
    setTimeout(() => {
      const input: any = document.getElementById("air_total_volume");
      if (input) input.value = num.toFixed(2);
    });
  }

    async reSearch(model:AirModel) {
      this.isLoading = true;
      this.productLoading = true;
  
        try {
        
          const segment = await this.airService.segment(this.model.departurePort.id, this.model.arrivalPort.id).toPromise();
          this.model.segment = segment;
          this.model.products = null;
        ;

          const result = await this.airService.search(this.model).toPromise();
          this.model = { ...result };     
  
          if (this.dynamicComponentRef && this.dynamicComponentRef.instance) {
  
            this.dynamicComponentRef.instance.model = this.model;
            if (this.dynamicComponentRef.instance.cdr) {
                this.dynamicComponentRef.instance.cdr.detectChanges();
            }
  
            // tekrar fiyat arandığı için ilgili bağlı component'in yeniden init ediyoruz....
            if (this.dynamicComponentRef.instance instanceof AirPriceRequestComponent) {
                if (typeof this.dynamicComponentRef.instance.ngOnInit === 'function') {
                    this.dynamicComponentRef.instance.ngOnInit();
                }
            }
          }
          
          this.sseService.setReady();
  
          this.isLoading = false;
          this.productLoading = false;
        } catch {
          this.isLoading = false;
          this.productLoading = false;
        }
        
        
    }

}
